export const Loader = {
	template: `
		<div class="calendar-sharing-event__loader_box">
			<svg class="calendar-sharing-event_circular" viewBox="25 25 50 50">
				<circle class="calendar-sharing-event_path" cx="50" cy="50" r="20" fill="none" stroke-miterlimit="10"/>
			</svg>
		</div>
	`,
};
